import { fromJS } from 'immutable'
import { RxCustomerAPI } from '@driftt/dapper'

export const api = {
  fetch() {
    return RxCustomerAPI
      .get('/overview')
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(fromJS)
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/org/overview/api.js